'use client';
import Dropdown from '@/components/dropdown/dropdown.component';
import LoadingSpinner from '@/components/loading-spinner/loadingSpinner';
import { LIST_STATES_UF, PRIORITY_ORDER_BIKE, PRIORITY_ORDER_CAR } from '@/helpers/constants';
import useFilters from './vehicle.hook';

const VehicleFilters = () => {
    const {
        brands,
        models,
        years,
        versions,
        selectedBrand,
        selectedModel,
        selectedYear,
        selectedVersion,
        selectedStateUF,
        handleBrandSelect,
        handleModelSelect,
        handleYearSelect,
        handleVersionSelect,
        handleStateUFSelect,
        redirectResult,
        initialSelections,
        isBike,
        isBrandLoading,
        isModelLoading,
        isYearLoading,
        isResultLoading,
    } = useFilters();

    const PRIORITY_ORDER = isBike ? PRIORITY_ORDER_BIKE : PRIORITY_ORDER_CAR;

    const vehicleType = isBike ? 'bike' : 'car';
    const yearFieldClassName = isBike || initialSelections.brand ? '' : 'filter-year';

    const enableButton = () => {
        if (isBike) {
            return !!selectedYear?.value;
        }
        return !!selectedVersion?.value;
    }

    const renderDropdown = ({
        id,
        placeholder,
        placeholderTitle,
        options,
        onSelect,
        selected,
        isEnabled,
        separatorIndex,
        className,
        blockRender,
        isLoading,
    }: any) =>
        !blockRender && (
            <div className={className}>
                <Dropdown
                    id={id}
                    placeholder={placeholder}
                    placeholderTitle={placeholderTitle}
                    initialOptions={options}
                    onSelect={onSelect}
                    selectValue={selected}
                    isDisabled={!isEnabled}
                    separatorIndex={separatorIndex}
                    isLoading={isLoading}
                />
            </div>
        );

    return (
        <>
            {renderDropdown({
                id: `${vehicleType}-select-marca`,
                placeholder: 'Selecione a marca',
                placeholderTitle: 'Marca',
                options: brands?.list,
                onSelect: handleBrandSelect,
                selected: selectedBrand,
                isEnabled: true,
                separatorIndex: 9,
                className: '',
                blockRender: initialSelections?.brand
            })}

            {renderDropdown({
                id: `${vehicleType}-select-modelo`,
                placeholder: 'Selecione o modelo',
                placeholderTitle: 'Modelo',
                options: models,
                onSelect: handleModelSelect,
                selected: selectedModel,
                isEnabled: !!selectedBrand?.value,
                separatorIndex: selectedBrand && PRIORITY_ORDER.includes(selectedBrand.label) ? 4 : Infinity,
                className: '',
                blockRender: initialSelections?.model,
                isLoading: isBrandLoading
            })}

            {renderDropdown({
                id: `${vehicleType}-select-ano`,
                placeholder: 'Selecione o ano',
                placeholderTitle: 'Ano',
                options: years,
                onSelect: handleYearSelect,
                selected: selectedYear,
                isEnabled: !!selectedModel?.value,
                className: !selectedModel ? `disabled ${yearFieldClassName}` : `${yearFieldClassName}`,
                blockRender: initialSelections?.year,
                isLoading: isModelLoading
            })}

            {!isBike &&
                renderDropdown({
                    id: 'car-select-versao',
                    placeholder: 'Selecione a versão',
                    placeholderTitle: 'Versão',
                    options: versions,
                    onSelect: handleVersionSelect,
                    selected: selectedVersion,
                    isEnabled: !!selectedYear?.value,
                    className: '',
                    blockRender: initialSelections?.version,
                    isLoading: isYearLoading
                })}

            {renderDropdown({
                id: `${vehicleType}-select-estado`,
                placeholder: 'Selecione o estado',
                placeholderTitle: 'Estado',
                options: LIST_STATES_UF,
                onSelect: handleStateUFSelect,
                selected: selectedStateUF,
                isEnabled: isBike ? !!selectedYear?.value : !!selectedVersion?.value,
                className: !selectedYear ? 'disabled' : '',
            })}

            <button
                id={`${vehicleType}-button-search`}
                data-testid={`${vehicleType}-button-search`}
                onClick={redirectResult}
                disabled={!enableButton()}
                className={`btn__secondary button-search-value ${enableButton() ? 'active' : ''}`}
                type="button"
            >
                {isResultLoading ? <LoadingSpinner white /> : 'Consultar valor'}
            </button>
        </>
    );
};

export default VehicleFilters;
